import {NgModule} from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from '@angular/forms';

import { PipesModule } from "libraries/pipes/pipes.module";
import { ProcessingStatusListComponent } from "./processing-status-list.component";
import { ExpandableProcessingStatusComponent } from "./expandable-processing-status.component";
import { ProcessingStatusComponent } from "./processing-status.component";
import { BtnModule } from "libraries/ui_button/btn.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        PipesModule,
        CommonModule,
        BtnModule,
        FormsModule,
        FontAwesomeModule,
    ],
    declarations:[
        ProcessingStatusListComponent,
        ExpandableProcessingStatusComponent,
        ProcessingStatusComponent,
    ],
    exports:[
        ProcessingStatusListComponent,
        ExpandableProcessingStatusComponent,
        ProcessingStatusComponent,
    ]
})
export class ProcessingStatusModule { }
